import React, { useState } from "react";
import AgGridWrapper from "../../../../../components/AgGridWrapper/AgGridWrapper";
import ActionButtons from "../../../../../components/ActionButtons";
import { changeStatus, setGrid } from "../../utils/slice";
import columnDefs from "./columnDefs";
import ConfirmModal from "../../../../../components/Modals/ConfirmModal";
import { useAppSelector } from "../../../../../utils/hooks/hooks";

/**
 * Renders a listing component for the RoleManagement module.
 *
 * @param {Object} props - The props object containing the following properties:
 *   - moduleInfo: The information about the module.
 *   - handleViewClick: The function to handle the view click event.
 *   - handleDeleteClick: The function to handle the delete click event.
 *   - handleEditClick: The function to handle the edit click event.
 * @return {JSX.Element} The rendered listing component.
 */
const Listing: React.FC<any> = ({
  moduleInfo,
  handleViewClick,
  handleDeleteClick,
  handleEditClick,
}) => {
  const role = useAppSelector(state => state.role);
  const [statusData, setStatusData] = useState<any>();

  /**
   * Renders ActionRenderer component for the ag grid contains the action buttons.
   */
  const ActionRenderer = (props: any) => {
    return (
      <ActionButtons
        data={props}
        view={{
          action: props?.data?.id !== 1 && handleViewClick,
          permissionKey: `${moduleInfo.permissionKeyPrefix}_DETAILS`,
        }}
        edit={{
          action: props?.data?.id !== 1 && handleEditClick,
          permissionKey: `${moduleInfo.permissionKeyPrefix}_UPDATE`,
        }}
        deleteButton={{
          action: props?.data?.id !== 1 && handleDeleteClick,
          permissionKey: `${moduleInfo.permissionKeyPrefix}_DELETE`,
        }}
      />
    );
  };

  return (
    <>
      <ConfirmModal
        titleName={moduleInfo.title}
        data={statusData}
        close={() => setStatusData(null)}
        callApi={changeStatus}
      />
      <AgGridWrapper
        components={{
          ActionRenderer,
        }}
        rowData={role.rowData}
        onGridReadyWithDispatch={setGrid}
        columnDefs={columnDefs}
        context={{ setStatusData }}
        paginationPageSize={role.perPage}
        cacheBlockSize={role.perPage}
      />
    </>
  );
};

export default Listing;
